import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/personal-storage-options.jpg'),
    alt: 'personal storage options page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'personal storage options page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Tailored <span>Personal</span><span>Storage Options</span>',
  description:
    'Looking for a safe and convenient way to store your personal items? Our personal storage options offer flexible, secure, and affordable solutions to keep your belongings safe and organized.',
  image: {
    url: '/images/v2/pages/landing-pages/personal-storage-options/hero-image.jpg',
    alt: 'Tailored Personal Storage Options'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Your Personal Storage' }
}

export const ourProcessSectionContent = {
  title: 'How Our Personal Storage Options Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/personal-storage-options/how-our-personal-storage-options-work.png',
    alt: 'How Our Personal Storage Options Work'
  },

  articles: [
    {
      id: 1,
      title: 'Flexible Storage Durations',
      description:
        'Choose from short-term or long-term storage options, designed to fit your specific needs, whether you need storage for a month or a year.',
      image: {
        src: '/images/v2/pages/landing-pages/personal-storage-options/flexible-storage-durations.png',
        alt: 'Flexible Storage Durations'
      }
    },
    {
      id: 2,
      title: 'Secure Storage Facilities',
      description:
        'Our state-of-the-art facilities are equipped with advanced security features, ensuring your personal items are protected at all times.',
      image: {
        src: '/images/v2/pages/landing-pages/personal-storage-options/secure-storage-facilities.png',
        alt: 'Secure Storage Facilities'
      }
    },
    {
      id: 3,
      title: 'Convenient Access',
      description:
        'Access your belongings whenever you need them with easy retrieval options and extended access hours.',
      image: {
        src: '/images/v2/pages/landing-pages/personal-storage-options/convenient-access.png',
        alt: 'Convenient Access'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable Personal Storage Solutions',
  description:
    'Our affordable personal storage solutions offer you peace of mind with secure, flexible options tailored to your needs. Whether you need extra space for belongings, seasonal items, or relocation, our facilities provide safe, budget-friendly choices to keep your possessions organized and easily accessible. Trust us for your storage needs!',
  image: {
    src: '/images/v2/pages/landing-pages/personal-storage-options/affordable-personal-storage-solutions.jpg',
    alt: 'Affordable Personal Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Our Personal Storage Options',

  cards: [
    {
      id: 1,
      title: 'Affordable Storage Solutions',
      description:
        'We offer cost-effective plans to meet your budget, so you don’t have to worry about overspending on storage.',
      image: {
        src: '/images/v2/pages/common/affordable-storage-solutions.png',
        alt: 'Affordable Storage Solutions'
      }
    },
    {
      id: 2,
      title: 'Top-Notch Security',
      description:
        'Your personal items are stored in highly secure, monitored facilities, ensuring the safety of your belongings.',
      image: {
        src: '/images/v2/pages/common/secure-and-reliable.png',
        alt: 'Top-Notch Security'
      }
    },
    {
      id: 3,
      title: 'Easy Access and Convenience',
      description: 'Access your stored items whenever you need them, with minimal hassle and maximum convenience.',
      image: {
        src: '/images/v2/pages/common/easy-access-and-convenience.png',
        alt: 'Easy Access and Convenience'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Our Personal Storage Options?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Homeowners in Need of Extra Space',
          description: 'Store seasonal items, extra furniture, or household goods without cluttering your living space.'
        },
        {
          id: 2,
          title: 'Students',
          description:
            'Store your personal belongings during the school year or between semesters with flexible storage options.'
        },
        {
          id: 3,
          title: 'People in Transition',
          description:
            'Whether you’re moving, renovating, or downsizing, our personal storage services provide the perfect solution.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/personal-storage-options/who-should-use-our-personal-storage-options.jpg',
        alt: 'Who Should Use Our Personal Storage Options?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Personal Storage Options',

  cards: [
    {
      id: 1,
      title: 'Seasonal Storage',
      description:
        'Store seasonal items such as clothing, holiday decorations, or sports gear when they’re not in use, freeing up space at home.',
      image: {
        src: '/images/v2/pages/common/residential-storage-services.png',
        alt: 'Seasonal Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Document and Personal Records Storage',
      description:
        'Keep your important documents and personal records safe and organized in our secure, climate-controlled storage units.',
      image: {
        src: '/images/v2/pages/common/document-and-personal-records-storage.png',
        alt: 'Document and Personal Records Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Furniture Storage',
      description:
        'Need to store extra furniture or valuable pieces? Our secure storage options ensure your items are safe and accessible.',
      image: {
        src: '/images/v2/pages/common/business-furniture-storage.png',
        alt: 'Furniture Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Sports Equipment Storage',
      description: 'Store your bulky sports equipment during the off-season and free up space in your garage or home.',
      image: {
        src: '/images/v2/pages/common/sports-equipment-storage.png',
        alt: 'Sports Equipment Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Personal Storage?',

  image: {
    url: '/images/v2/pages/landing-pages/personal-storage-options/why-choose-shipandstorage-for-personal-storage.jpg',
    alt: 'Why Choose ShipAndStorage for Personal Storage?'
  },

  articles: [
    {
      id: 1,
      title: 'Secure and Protected',
      description:
        'Our personal storage units are equipped with advanced security measures, including surveillance cameras and alarm systems, to ensure your belongings are safe.'
    },
    {
      id: 2,
      title: 'Customizable Storage Solutions',
      description:
        'Choose from a variety of unit sizes and storage durations, allowing you to tailor your storage experience to your needs.'
    },
    {
      id: 3,
      title: 'Affordable and Transparent Pricing',
      description:
        'We offer clear, competitive pricing without hidden fees, making it easy for you to plan your storage needs.'
    },
    {
      id: 4,
      title: 'Quick and Easy Setup',
      description:
        'Setting up your storage solution is fast and hassle-free, and our team is ready to assist you at any step.'
    },
    {
      id: 5,
      title: 'Flexible Access',
      description:
        'Access your belongings at your convenience, whether you need to retrieve a few items or your entire storage unit.'
    },
    {
      id: 6,
      title: 'Friendly Customer Support',
      description:
        'Our dedicated team is always available to assist you with any questions or concerns, ensuring you have a smooth and worry-free storage experience.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Find Personal Storage Options Tailored to You',
  description:
    'Personal storage options tailored for your needs. Affordable, secure solutions for storing your belongings safely and conveniently.',
  image: {
    src: '/images/v2/pages/landing-pages/personal-storage-options/find-personal-storage-options-tailored-to-you.png',
    alt: 'Find Personal Storage Options Tailored to You'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started Now' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Shipping Partners',
  description:
    'We work with leading global shipping companies to ensure your personal items are safely delivered to and from our storage facilities.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx provides reliable and timely shipping services, ensuring your personal items are transported safely to our storage locations.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers fast and secure international shipping services, helping to ensure the safe transport of your personal items to our storage facilities.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides secure and reliable shipping services for your personal storage needs, ensuring your belongings arrive safely and on time.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
